module.exports = __webpack_public_path__ + "img/chess_chinesechessred4.28d4130d.png";